/**
 * LocalStorage 유틸리티
 * 학생 인증 정보 저장/조회
 */

import { Student } from '../types/user';

// LocalStorage 키
const KEYS = {
  ACCESS_TOKEN: 'student_access_token',
  REFRESH_TOKEN: 'student_refresh_token',
  USER: 'student_user',
};

/**
 * Access Token 저장
 */
export const setAccessToken = (token: string): void => {
  localStorage.setItem(KEYS.ACCESS_TOKEN, token);
};

/**
 * Access Token 조회
 */
export const getAccessToken = (): string | null => {
  return localStorage.getItem(KEYS.ACCESS_TOKEN);
};

/**
 * Refresh Token 저장
 */
export const setRefreshToken = (token: string): void => {
  localStorage.setItem(KEYS.REFRESH_TOKEN, token);
};

/**
 * Refresh Token 조회
 */
export const getRefreshToken = (): string | null => {
  return localStorage.getItem(KEYS.REFRESH_TOKEN);
};

/**
 * 사용자 정보 저장
 */
export const setUser = (user: Student): void => {
  localStorage.setItem(KEYS.USER, JSON.stringify(user));
};

/**
 * 사용자 정보 조회
 */
export const getUser = (): Student | null => {
  const user = localStorage.getItem(KEYS.USER);
  if (!user) return null;

  try {
    return JSON.parse(user);
  } catch (error) {
    console.error('Failed to parse user data:', error);
    return null;
  }
};

/**
 * 모든 인증 데이터 삭제 (로그아웃)
 */
export const clearAuthData = (): void => {
  localStorage.removeItem(KEYS.ACCESS_TOKEN);
  localStorage.removeItem(KEYS.REFRESH_TOKEN);
  localStorage.removeItem(KEYS.USER);
};

/**
 * 인증 여부 확인
 */
export const isAuthenticated = (): boolean => {
  return !!getAccessToken() && !!getUser();
};
